import { data } from '../../svg/Blueprint/data';
import { makeIcon } from '../makeIcon';

export const Blueprint = makeIcon(data, 'blueprint', 'Blueprint');

export default Blueprint;
